import { useParams, Link } from "react-router-dom";
import api from "../../api/Api";
import { useEffect, useState } from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import dayjs from "dayjs";

function AssignLogsByAssets() {

  const { identy } = useParams();

  const [logs, setLogs] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [pageSize] = useState(8);
  const [sortField, setSortField] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const fetchLogs = (pageNo) => {
    api.post(
      `/api/assignments/logs/asset/${identy}`,
      {
        search: search && search.trim() !== "" ? search : null
      },
      {
        params: {
          page: pageNo,
          size: pageSize,
          sort: `${sortField},${sortOrder}`,
        }
      }
    )
    .then(res => {
      setLogs(res.data.response.content);
      setTotalPages(res.data.response.totalPages);
    })
    .catch(() => setLogs([]));
  };

  useEffect(() => {
    if (identy) fetchLogs(page);
  }, [identy, page, sortField, sortOrder]);


  // same pattern as Assets page ✔
  useEffect(() => {
    const delay = setTimeout(() => {
      setPage(0);
      fetchLogs(0);
    }, 100);

    return () => clearTimeout(delay);
  }, [search]);


  const handlePageChange = (e, value) => {
    setPage(value - 1);
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  const formatDate = (v) =>
    v ? dayjs(v).format("DD MMM YYYY • hh:mm A") : "—";


  return (
    <div className="container-fluid mt-1 pt-2 d-flex flex-column" style={{ height: "100%" }}>

      {/* HEADER */}
      <div className="d-flex">
        <Link to={-1} className="btn btn-secondary m-3" style={{ height: "40px" }}>
          ← Back
        </Link>

        <div className="mt-3 me-2">
          <h2 className="text-capitalize">Assignment Logs</h2>
        </div>

        <input
          className="form-control rounded-pill p-3 ms-3 mt-2 mb-3"
          style={{ width: "60%", maxWidth: "600px", fontSize: "15px" }}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by employee / status / notes..."
        />
      </div>


      {/* TABLE */}
      <div className="flex-grow-1">

        <table className="table table-bordered">
          <thead className="table">
            <tr>

              <th style={{cursor:'pointer',backgroundColor:"#0D59A7",color:"white"}}
                  onClick={() => handleSort("eventType")}>
                Event {sortField==="eventType" ? (sortOrder==="asc"?"↑":"↓"):""}
              </th>

              <th style={{cursor:'pointer',backgroundColor:"#0D59A7",color:"white"}}
                  onClick={() => handleSort("assignStatus")}>
                Status {sortField==="assignStatus" ? (sortOrder==="asc"?"↑":"↓"):""}
              </th>

              <th style={{cursor:'pointer',backgroundColor:"#0D59A7",color:"white"}}>Employee</th>
              <th style={{cursor:'pointer',backgroundColor:"#0D59A7",color:"white"}}>Assigned</th>
              <th style={{cursor:'pointer',backgroundColor:"#0D59A7",color:"white"}}>Returned</th>
              <th style={{cursor:'pointer',backgroundColor:"#0D59A7",color:"white"}}>Notes</th>
              <th style={{cursor:'pointer',backgroundColor:"#0D59A7",color:"white"}}>Remarks</th>
              <th style={{cursor:'pointer',backgroundColor:"#0D59A7",color:"white"}}
                  onClick={() => handleSort("createdAt")}>
                Logged At 
                {/* {sortField==="createdAt" ? (sortOrder==="asc"?"↑":"↓"):""} */}
              </th>

              <th style={{cursor:'pointer',backgroundColor:"#0D59A7",color:"white"}}>By</th>

            </tr>
          </thead>

          <tbody>

  {logs.length > 0 ? (

    logs.map((log, i) => (
      <tr key={i}>
        <td className="text-capitalize">{log.eventType || "-"}</td>
        <td className="text-capitalize">{log.assignStatus}</td>
        <td className="text-capitalize">{log.employeeName}</td>
        <td>{log.assignedDate || "-"}</td>
        <td>{log.returnedDate || "-"}</td>
        <td>{log.notes || "-"}</td>
        <td>{log.remarks || "-"}</td>
        <td>{formatDate(log.createdAt)}</td>
        <td>{log.createdBy || "-"}</td>
      </tr>
    ))

  ) : (

    <tr>
      <td colSpan="9" className="text-center text-muted py-4">
        No assignment logs available for this asset
      </td>
    </tr>

  )}

</tbody>


        </table>

      </div>


      {/* PAGINATION */}
      <div className="d-flex justify-content-center mt-2 mb-2">
        <Stack spacing={2}>
          <Pagination
            count={totalPages}
            page={page + 1}
            onChange={handlePageChange}
            color="primary"
            shape="rounded"
            variant="outlined"
          />
        </Stack>
      </div>

    </div>
  );
}

export default AssignLogsByAssets;
